export type DataOrError<T> =
  | { success: true, result: T }
  | { success: false, result: string };

export async function handleError<T>(action: () => Promise<T>): Promise<DataOrError<T>> {
  return action()
    .then(data => ({success: true as const, result: data}))
    .catch(e => ({success: false as const, result: e instanceof Error ? e.message : JSON.stringify(e)}))
}

export function projectsGroupId(companyId: number) {
  return `${companyId}-projects`
}

export const doneSectionKey = "done-projects"
export const backlogSectionKey = "backlog-projects"
export const laterSectionKey = "later-projects"
export const nowSectionKey = "now-projects"
export const nextSectionKey = "next-projects"